import styled from "styled-components"
import chroma from "chroma-js"

export const NumericScoreWrap = styled.div<{ width: number }>`
  width: ${props => props.width}px;
  display: grid;
  margin: 0 auto;
  grid-template-rows: ${props => props.width}px 1fr;
  user-select: none;
  padding: 0 0 1rem;
`

export const ScoreRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  > h4 {
    position: relative;
    z-index: 1;
    pointer-events: none;
  }
`

export const LabelRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
`

export const IconWrap = styled.div`
  position: absolute;
  top: 25%;
  width: 40%;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  text-align: center;
  opacity: 1;
`

export const Delta = styled.div`
  position: absolute;
  top: -0.25rem;
  right: -0.25rem;
  font-size: 1rem;
  border: none;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;

  > span {
    font-size: 1rem;
  }
`

type TVariantBgs = {
  [key: string]: {
    inner: string
    outer: string
  }
}

const variantBgs: TVariantBgs = {
  dark__default: {
    inner:
      "linear-gradient(0deg,rgba(41, 47, 61, 0.1) 0%,rgba(41, 47, 61, 0.1) 100%)",
    outer: `linear-gradient(0deg,rgba(15,17,22, 0.9) 0%,rgba(15,17,22, 0.9) 100%) padding-box,linear-gradient(45deg,rgb(67,257,162) 0%,rgba(0, 0, 0,0) 25%, rgba(0, 0, 0,0) 75%,rgb(67,257,162) 100%) border-box`
    // "linear-gradient(0deg,rgb(15, 17, 22) 0%,rgb(15, 17, 22) 100%) padding-box, linear-gradient(to right, #9c20aa, #fb3570) border-box"
  },
  light__default: {
    inner: "rgb(255, 255, 241)",
    outer: "rgb(241, 241, 241)"
  }
}

const getPresetVariantBg = (key: string) =>
  Object.keys(variantBgs).includes(key) ? variantBgs[key] : null

export const ScoreBackground = styled.div<{
  color: string
  isDefault: boolean
  colorKey: string
  baseTheme: string
}>`
  position: absolute;
  width: 80%;
  height: 80%;
  border: 1px solid ${({ color, isDefault }) =>
    isDefault ? "rgb(85 85 85)" : chroma(color).alpha(0.7).css()};

  /* box-shadow: 0 0 5px -10px rgb(15, 17, 22); */
  border-radius: 50%;
  transition: all 0.6s ease;
  transform: scale(1);
  cursor: pointer;

  &::before {
    content: "";
    position: absolute;
    width: 80%;
    height: 80%;
    border-radius: 50%;
    left: 10%;
    top: 10%;
    box-shadow: inset 0px 0px 5px rgba(255, 255, 255, 0.09);
    transition: background-image 0.6s ease;
    background: ${({ baseTheme = "light", color, colorKey = "", isDefault }) =>
      getPresetVariantBg(`${baseTheme}__${colorKey}`)?.inner ||
      chroma(color)
        .alpha(isDefault ? 0.05 : 0.3)
        .css()}

  &:hover {
    transform: scale(1.1);
  }
`
